import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";

const ProtectedRoute = () => {
  const { user, initializing } = useAuth();
  const location = useLocation();

  // 1. Show loader while we don't know the auth state
  if (initializing) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  // 2. If we’re done initializing and there’s no user, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. If user exists but is not admin, redirect to home
  const isAdmin = user.userType === "ADMIN" || user.userType === "ADMIN_USER" || user.userType === 'BUYER';
  if (!isAdmin) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Typography>You do not have access to this page.</Typography>
      </Box>
    );
  }

  // 4. Authorized route
  return <Outlet />;
};

export default ProtectedRoute;